import { atom } from 'recoil';

export const CanAddDestinationState = atom({
    key: 'CanAddDestinationState',
    default: false,
});